import React, { useState } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
import settings from '../../constants/settings';

const WhatsAppCTA = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  
  return (
    <div className={cn(
      "fixed bottom-6 right-6 z-50 flex flex-col items-end",
      isExpanded ? "shadow-lg" : ""
    )}>
      {/* Floating Button */}
      <button 
        onClick={toggleExpand}
        className="flex items-center justify-center bg-[#25D366] hover:bg-[#20BD5C] text-white border-2 border-[#25D366] rounded-full h-14 w-14 shadow-lg transition-all"
      >
        <svg
          className="w-7 h-7"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </button>
      
      {/* Expanded Content */}
      {isExpanded && (
        <div className="mt-4 w-80 bg-white rounded-lg shadow-xl overflow-hidden animate-in slide-in-from-bottom-5 duration-300">
          {/* Header */}
          <div className="flex items-center justify-between p-4 bg-dark-navy text-light-cream">
            <h3 className="font-bold">Gabung #PintarPilihKuliah</h3>
            <button
              onClick={toggleExpand}
              className="text-light-cream hover:text-cream"
            >
              <X size={20} />
            </button>
          </div>
          
          {/* Content */}
          <div className="p-4">
            <p className="text-gray-700 mb-4">
              Bergabunglah dengan komunitas kami untuk mendapatkan informasi terbaru seputar beasiswa dan kesempatan pendidikan luar negeri.
            </p>
            
            <div className="flex flex-col space-y-2">
              <a 
                href={settings.wa_group_link}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-2 bg-cream hover:bg-light-cream text-dark-navy text-center rounded-md font-medium border border-gold transition-colors"
              >
                Grup WA Info Beasiswa
              </a>
              
              <a 
                href={settings.wa_consultant_link} 
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-2 bg-dark-navy hover:bg-gray text-gold hover:text-light-cream text-center rounded-md font-medium transition-colors"
              >
                Chat Langsung dengan Konsultan
              </a>
            </div>
          </div>
          
          {/* Footer */}
          <div className="px-4 py-3 bg-light-cream border-t border-cream text-center text-xs text-gray">
            Jam operasional: Senin-Jumat, 09.00-17.00 WIB
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppCTA;
